import { all } from 'redux-saga/effects';
import { handleOnHydrateSearch } from '@state/deal-finder-last-searched/dealFinderLastSearchedOperations';

export function* combinedDealFinderLastSearchedSagas() {
  yield all([handleOnHydrateSearch()]);
}
